import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ifProp, switchProp } from 'styled-tools';

const Wrapper = styled.span`
  height: 14px; /* 14px */
  width: 14px; /* 14px */
  border: 1px solid #b7b7b7;
  border-radius: 5px;
  /* background-color: ${switchProp("checkState",{
    empty: 'white',
    checked: 'red',
    X: 'blue',
  })}; */
`

const getCheckboxContent = (checkboxState) => {
  if (checkboxState === 'checked')
    return <span>&#10003;</span>;

  if (checkboxState === 'X')
    return <span>X</span>;

  return ''
}

const ThreeStateCheckboxSpan = (props) => {
  const { checkState } = props;

  return <Wrapper checkState={checkState}>{getCheckboxContent(checkState)}</Wrapper>
}

ThreeStateCheckboxSpan.propTypes = {
  type: PropTypes.string,
  reverse: PropTypes.bool,
  invalid: PropTypes.bool,
  label: PropTypes.string,
};

export default ThreeStateCheckboxSpan;;
